/* eslint-disable */
/**
 * GENERATED FILE, DO NOT EDIT.
 *
 * Source:    design-system/beast.tokens.json
 * Regenerate: node design-system/build.mjs
 *
 * A hand edit here is reverted by the next build and fails the drift test in
 * CI. Change the token source instead: that is what keeps the accent one
 * value across four surfaces instead of four values across four surfaces.
 */


export const tokensVersion = '1.1.0' as const


/** Neutrals, accent, role and brand colours, resolved per colour scheme. */
export const colorTokens = {
  light: {
    ink: '#121212',
    brandSurface: '#121212',
    onBrandSurface: '#FFFFFF',
    greyDarker: '#242424',
    greyDark: '#4D5156',
    greyDeep: '#33373B',
    greyText: '#A2A7AE',
    greySecondary: '#B5B9BE',
    greyRegular: '#D4D8DD',
    greyOutline: '#EDF0F3',
    greyLight: '#F4F5F7',
    greyLightest: '#FBFBFB',
    white: '#FFFFFF',
    accent: '#3D6AE0',
    accentDark: '#1E73BE',
    accentLight: '#D0E1FB',
    accentLightInk: '#1A3A6B',
    accentText: '#3D6AE0',
    accentRing: 'rgba(61,106,224,0.35)',
    surface: '#FFFFFF',
    surface2: '#FBFBFB',
    surfaceSunken: '#F4F5F7',
    surfaceSunkenStrong: '#E6E9ED',
    border: '#EDF0F3',
    borderStrong: '#D4D8DD',
    controlEdge: '#7F858E',
    text1: '#121212',
    text2: '#4D5156',
    text3: '#A2A7AE',
    textDisabled: '#B5B9BE',
    onAccent: '#FFFFFF',
    onWarning: '#121212',
    onError: '#121212',
    onSuccess: '#121212',
    chargeSupercharger: '#CC0000',
    chargeAc: '#1F6B43',
    chargeDc: '#1E73BE',
    estimated: '#1A3A6B',
    onEstimated: '#FFFFFF',
    onAttention: '#121212',
    scrim: 'rgba(0,0,0,0.45)',
    onInk: '#FFFFFF',
    tooltip: '#242424',
    onTooltip: '#FFFFFF',
    pictureGround: '#FFFFFF',
    scrollbarThumb: '#7F858E',
    photoCaption: 'rgba(0,0,0,0.60)',
    tesla: '#CC0000',
    teslaPressed: '#A30000',
    google: '#FFFFFF',
    googlePressed: '#F2F2F2',
    googleEdge: '#747775',
    googleText: '#1F1F1F',
    apple: '#000000',
    applePressed: '#333333',
    appleText: '#FFFFFF',
    pureBlack: '#000000',
    pureWhite: '#FFFFFF',
  },
  dark: {
    ink: '#F4F5F7',
    brandSurface: '#121212',
    onBrandSurface: '#FFFFFF',
    greyDarker: '#E6E8EB',
    greyDark: '#B5B9BE',
    greyDeep: '#CDD1D6',
    greyText: '#80858C',
    greySecondary: '#5A5F66',
    greyRegular: '#383C41',
    greyOutline: '#2A2D31',
    greyLight: '#232629',
    greyLightest: '#141517',
    white: '#1B1D21',
    accent: '#3D6AE0',
    accentDark: '#5B86F0',
    accentLight: 'rgba(61,106,224,0.20)',
    accentLightInk: '#AFC6F5',
    accentText: '#7CA0F2',
    accentRing: 'rgba(91,134,240,0.45)',
    surface: '#1B1D21',
    surface2: '#141517',
    surfaceSunken: '#232629',
    surfaceSunkenStrong: '#2E3236',
    border: '#2A2D31',
    borderStrong: '#383C41',
    controlEdge: '#80858C',
    text1: '#F4F5F7',
    text2: '#B5B9BE',
    text3: '#80858C',
    textDisabled: '#5A5F66',
    onAccent: '#FFFFFF',
    onWarning: '#121212',
    onError: '#121212',
    onSuccess: '#121212',
    chargeSupercharger: '#F4756D',
    chargeAc: '#6FD6A6',
    chargeDc: '#7CA0F2',
    estimated: '#1A3A6B',
    onEstimated: '#AECBFA',
    onAttention: '#121212',
    scrim: 'rgba(0,0,0,0.60)',
    onInk: '#1B1D21',
    tooltip: '#4D5156',
    onTooltip: '#FFFFFF',
    pictureGround: '#FFFFFF',
    scrollbarThumb: '#80858C',
    photoCaption: 'rgba(0,0,0,0.60)',
    tesla: '#CC0000',
    teslaPressed: '#A30000',
    google: '#131314',
    googlePressed: '#2A2A2C',
    googleEdge: '#8E918F',
    googleText: '#E3E3E3',
    apple: '#FFFFFF',
    applePressed: '#E6E6E6',
    appleText: '#000000',
    pureBlack: '#000000',
    pureWhite: '#FFFFFF',
  },
} as const


/** Each semantic is a set of roles, not a single colour: a fill for meters, a soft background for chips, and text that is legible on it. */
export const semanticTokens = {
  light: {
    success: {
      fill: '#039A5A',
      fillHover: '#26A871',
      brightFill: '#7CD369',
      soft: '#DAF1E4',
      text: '#1F6B43',
      deep: '#0B4F31',
    },
    warning: {
      fill: '#FCCD00',
      fillHover: '#FCD424',
      brightFill: '#FFE16A',
      soft: '#FBF1CC',
      text: '#735607',
      deep: '#C79F00',
    },
    error: {
      fill: '#F85D54',
      fillHover: '#F9746C',
      brightFill: '#FB9A93',
      soft: '#FBDAD7',
      text: '#8A2A24',
      deep: '#D6453B',
    },
    attention: {
      fill: '#FF8F28',
      fillHover: '#FF9F46',
      brightFill: '#FFB673',
      soft: '#F8DDC5',
      text: '#6B3415',
      deep: '#C86A12',
    },
    info: {
      fill: '#3D6AE0',
      fillHover: '#345BC1',
      brightFill: '#84A9FF',
      soft: '#D9E5FB',
      text: '#1A3A6B',
      deep: '#1E73BE',
    },
    tip: {
      fill: '#F2C14E',
      fillHover: '#F4CB69',
      brightFill: '#F9E2A2',
      soft: '#FDF7DF',
      text: '#5C4810',
      deep: '#B38714',
    },
  },
  dark: {
    success: {
      fill: '#3FBE84',
      fillHover: '#5AC795',
      brightFill: '#2C8E62',
      soft: 'rgba(3,154,90,0.20)',
      text: '#6FD6A6',
      deep: '#0B4F31',
    },
    warning: {
      fill: '#FAD24B',
      fillHover: '#FBD864',
      brightFill: '#FFE16A',
      soft: 'rgba(252,205,0,0.16)',
      text: '#E6CE72',
      deep: '#C79F00',
    },
    error: {
      fill: '#F4756D',
      fillHover: '#F68881',
      brightFill: '#FB9A93',
      soft: 'rgba(248,93,84,0.18)',
      text: '#F2A39C',
      deep: '#D6453B',
    },
    attention: {
      fill: '#FF9D45',
      fillHover: '#FFAB5F',
      brightFill: '#FFB673',
      soft: 'rgba(255,143,40,0.18)',
      text: '#F4C39A',
      deep: '#C86A12',
    },
    info: {
      fill: '#3D6AE0',
      fillHover: '#345BC1',
      brightFill: '#84A9FF',
      soft: 'rgba(61,106,224,0.20)',
      text: '#AECBFA',
      deep: '#1E73BE',
    },
    tip: {
      fill: '#F2CC66',
      fillHover: '#F5D57F',
      brightFill: '#8C6F1F',
      soft: 'rgba(245,200,80,0.12)',
      text: '#EBD9A0',
      deep: '#B38714',
    },
  },
} as const


/** Eight pastels plus grey, for things that differ without ranking. */
export const categoricalTokens = {
  light: {
    blue: {
      bg: '#D9E5FB',
      text: '#1A3A6B',
      vivid: '#3D6AE0',
    },
    mint: {
      bg: '#D8EFE3',
      text: '#1F4A39',
      vivid: '#039A5A',
    },
    peach: {
      bg: '#F8DDC5',
      text: '#6B3415',
      vivid: '#FF8F28',
    },
    lavender: {
      bg: '#E5DEFA',
      text: '#3F2A6B',
      vivid: '#7C63E0',
    },
    pink: {
      bg: '#FBDDE5',
      text: '#6B1F3A',
      vivid: '#E8598C',
    },
    yellow: {
      bg: '#FBF3D2',
      text: '#5B4A0A',
      vivid: '#E5B800',
    },
    cyan: {
      bg: '#D5ECF1',
      text: '#1F4A5C',
      vivid: '#2896B4',
    },
    coral: {
      bg: '#FAD8D2',
      text: '#6B2C1F',
      vivid: '#F85D54',
    },
    grey: {
      bg: '#EDF0F3',
      text: '#4D5156',
      vivid: '#6B7076',
    },
  },
  dark: {
    blue: {
      bg: 'rgba(61,106,224,0.20)',
      text: '#AECBFA',
      vivid: '#6B92F0',
    },
    mint: {
      bg: 'rgba(3,154,90,0.22)',
      text: '#8FE3BE',
      vivid: '#2FC28A',
    },
    peach: {
      bg: 'rgba(255,143,40,0.18)',
      text: '#F4C39A',
      vivid: '#FFA855',
    },
    lavender: {
      bg: 'rgba(124,99,224,0.24)',
      text: '#CFC2F5',
      vivid: '#9B85F0',
    },
    pink: {
      bg: 'rgba(232,89,140,0.20)',
      text: '#F3B6CC',
      vivid: '#F27BA6',
    },
    yellow: {
      bg: 'rgba(252,205,0,0.18)',
      text: '#E8D88A',
      vivid: '#FCCD00',
    },
    cyan: {
      bg: 'rgba(40,150,180,0.24)',
      text: '#A6D8E5',
      vivid: '#4FB8D6',
    },
    coral: {
      bg: 'rgba(248,93,84,0.20)',
      text: '#F2B3AA',
      vivid: '#FA7F78',
    },
    grey: {
      bg: '#2A2D31',
      text: '#B5B9BE',
      vivid: '#8D9298',
    },
  },
} as const


/** The pastels a tag is made in, in the order a new tag takes them: the first one no other tag of the provider is drawn in, else the one fewest wear. */
export const tagTokens = {
  pastels: [
    'blue',
    'mint',
    'peach',
    'lavender',
    'pink',
    'yellow',
    'cyan',
    'coral',
  ],
} as const


/** Series colours for console charts: an ordered list of categorical names, resolved to the categorical vivid in the active scheme; the booked and freestyle pair, resolved per colour scheme; the Costs and Business bindings, each a categorical name; profit and loss, each a semantic and slot; and the dash and corner a chart draws with. */
export const chartTokens = {
  series: [
    'blue',
    'mint',
    'peach',
    'lavender',
    'pink',
    'cyan',
    'yellow',
    'coral',
  ],
  rentalType: {
    light: {
      booking: '#1A3A6B',
      freestyle: '#2B8FE0',
    },
    dark: {
      booking: '#4A74D9',
      freestyle: '#9ED8FF',
    },
  },
  costs: {
    revenue: 'blue',
    costs: 'pink',
    categories: {
      hosting: 'blue',
      vehicleData: 'lavender',
      identity: 'mint',
      support: 'peach',
      monitoring: 'coral',
      payments: 'yellow',
      tooling: 'grey',
      messaging: 'pink',
      maps: 'cyan',
    },
  },
  profitLoss: {
    profit: {
      semantic: 'success',
      slot: 'fill',
    },
    loss: {
      semantic: 'error',
      slot: 'fill',
    },
  },
  referenceDash: '4 3',
  barRadius: 2,
  barRadiusWide: 3,
} as const


/** Shapes drawn on a map: each role names the categorical whose vivid mark it takes in the active scheme, with the fill opacity and edge width. */
export const mapTokens = {
  returnArea: {
    designated: 'mint',
    allowed: 'blue',
    shared: 'lavender',
    off: 'grey',
    selected: 'coral',
    fillOpacity: 0.2,
    lineWidth: 2,
  },
} as const


/** Points on a rental's timeline: each names the categorical whose vivid the point takes in the active scheme. */
export const timelineTokens = {
  bookedStart: 'mint',
  bookedEnd: 'lavender',
} as const


/** The 8px scale. 4 is the only sub-8 step. */
export const space = {
  s1: 4,
  s2: 8,
  s3: 12,
  s4: 16,
  s5: 20,
  s6: 24,
  s8: 32,
  s10: 40,
  s12: 48,
  s16: 64,
} as const


export const spaceUnit = 8 as const


/** Four roles, two ramps. The tier decides which ramp applies. */
export const radius = {
  expressive: {
    inline: 5,
    control: 12,
    surface: 20,
    pill: 999,
  },
  console: {
    inline: 5,
    control: 10,
    surface: 14,
    pill: 999,
  },
} as const


/** Four levels. e0 is flat with a 1px border and is the default for every resting surface. */
export const elevation = {
  light: {
    e0: 'none',
    e1: '0 1px 0 rgba(18,18,18,0.04)',
    e2: '0 14px 40px rgba(18,18,18,0.08)',
    e3: '0 20px 60px rgba(18,18,18,0.12)',
  },
  dark: {
    e0: 'none',
    e1: '0 1px 0 rgba(0,0,0,0.4)',
    e2: '0 14px 40px rgba(0,0,0,0.55)',
    e3: '0 20px 60px rgba(0,0,0,0.65)',
  },
} as const


/** The closed set of seven named motions. A movement not on this list does not ship. */
export const motion = {
  easing: {
    standard: 'cubic-bezier(0.2,0,0.4,1)',
    out: 'cubic-bezier(0.2,0.7,0.3,1)',
    inOut: 'cubic-bezier(0.45,0,0.55,1)',
  },
  dwell: {
    confirm: 3000,
    hintLeave: 120,
  },
  state: {
    duration: 120,
    easing: 'standard',
    tiers: [
      1,
      2,
      3,
    ],
    reducedMotion: 'keep',
  },
  enter: {
    duration: 200,
    easing: 'out',
    tiers: [
      1,
      2,
      3,
    ],
    reducedMotion: 'instant',
  },
  sheet: {
    duration: 260,
    easing: 'out',
    tiers: [
      1,
      2,
      3,
    ],
    reducedMotion: 'instant',
  },
  reveal: {
    duration: 520,
    easing: 'out',
    tiers: [
      1,
    ],
    reducedMotion: 'off',
    stagger: 60,
    maxItems: 6,
  },
  gloss: {
    duration: 900,
    easing: 'linear',
    tiers: [
      1,
    ],
    reducedMotion: 'off',
  },
  crossfade: {
    duration: 1200,
    easing: 'inOut',
    tiers: [
      1,
    ],
    reducedMotion: 'off',
  },
  pulse: {
    duration: 1400,
    easing: 'inOut',
    tiers: [
      2,
      3,
    ],
    reducedMotion: 'static',
    loop: true,
  },
} as const


export const typography = {
  families: {
    ui: {
      stack: '\'Heebo\', system-ui, -apple-system, \'Segoe UI\', sans-serif',
      capRise: 0.042,
    },
    display: {
      stack: '\'Stack Sans Headline\', \'Archivo\', \'Heebo\', system-ui, sans-serif',
    },
    notch: {
      stack: '\'Stack Sans Notch\', \'Stack Sans Headline\', \'Heebo\', system-ui, sans-serif',
    },
    mono: {
      stack: '\'IBM Plex Mono\', ui-monospace, SFMono-Regular, \'SF Mono\', Menlo, Consolas, monospace',
    },
  },
  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  marketing: {
    display: {
      size: 52,
      lineHeight: 1.04,
      weight: 700,
      letterSpacing: '-0.028em',
    },
    h2: {
      size: 36,
      lineHeight: 1.12,
      weight: 700,
      letterSpacing: '-0.022em',
    },
    h3: {
      size: 24,
      lineHeight: 1.2,
      weight: 700,
      letterSpacing: '-0.014em',
    },
    body: {
      size: 17,
      lineHeight: 1.55,
      weight: 400,
    },
    small: {
      size: 15,
      lineHeight: 1.5,
      weight: 400,
    },
    label: {
      size: 13,
      lineHeight: 1,
      weight: 600,
      letterSpacing: '0.06em',
      caps: true,
    },
  },
  driver: {
    h1: {
      size: 32,
      lineHeight: 1.1,
      weight: 700,
    },
    h2: {
      size: 22,
      lineHeight: 1.2,
      weight: 700,
    },
    h3: {
      size: 17,
      lineHeight: 1.25,
      weight: 600,
    },
    body: {
      size: 15,
      lineHeight: 1.5,
      weight: 400,
    },
    small: {
      size: 13,
      lineHeight: 1.45,
      weight: 400,
    },
    label: {
      size: 11,
      lineHeight: 1,
      weight: 600,
      letterSpacing: '0.06em',
      caps: true,
    },
  },
  console: {
    display: {
      size: 34,
      lineHeight: 1.1,
      weight: 700,
      letterSpacing: '-0.02em',
    },
    h1: {
      size: 24,
      lineHeight: 1.15,
      weight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      size: 20,
      lineHeight: 1.25,
      weight: 700,
      letterSpacing: '-0.015em',
    },
    h3: {
      size: 18,
      lineHeight: 1.3,
      weight: 700,
      letterSpacing: '-0.01em',
    },
    cardTitle: {
      size: 17,
      lineHeight: 1.35,
      weight: 700,
    },
    groupTitle: {
      size: 15,
      lineHeight: 1.4,
      weight: 600,
    },
    subhead: {
      size: 14,
      lineHeight: 1.45,
      weight: 600,
    },
    body: {
      size: 14,
      lineHeight: 1.45,
      weight: 400,
    },
    small: {
      size: 13,
      lineHeight: 1.45,
      weight: 400,
    },
    caption: {
      size: 12,
      lineHeight: 1.4,
      weight: 400,
    },
    label: {
      size: 11,
      lineHeight: 1,
      weight: 600,
      letterSpacing: '0.06em',
      caps: true,
    },
    button: {
      size: 14,
      lineHeight: 1.5,
      weight: 600,
    },
  },
  numeric: {
    fontVariant: 'tabular-nums',
  },
} as const


export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const


/** How a moment is written, chosen by what the reader is deciding rather than by what the value happens to carry. Every timestamp in the product is a full instant; the format is where the console says which part of it matters */
export const dateFormats = {
  day: 'd MMM yyyy',
  minute: 'd MMM yyyy, HH:mm',
  second: 'd MMM yyyy, HH:mm:ss',
  dayInMonth: 'd MMM',
  month: 'MMMM yyyy',
} as const


/** A chart's own tick labels, which are the one place a date is written short. An axis has room for about five characters and its neighbours supply the context a sentence would have to carry, so the day format that is right in a table is wrong here. Named per bucket rather than left to the chart, so two charts bucketing the same way cannot label it differently */
export const axisDateFormats = {
  weekday: 'EEE',
  dayMonth: 'd MMM',
  isoWeek: '\'W\'II',
  month: 'MMM',
} as const


export const layout = {
  headerHeight: 60,
  mobileHeaderHeight: 52,
  footerHeight: 64,
  sidebarWidth: 240,
  sidebarRailWidth: 64,
  navItemHeight: 44,
  navLeafHeight: 36,
  entryPanelWidth: 480,
  entryPanelBandHeight: 180,
  entryFormWidth: 360,
  stepMark: 26,
  brandMark: 40,
  brandMarkNav: 32,
  brandWordmark: 16,
  brandWordmarkLead: 28,
  pageGutterCompact: 2,
  pageGutter: 3,
  sectionRuleWidth: 90,
  tableHeaderHeight: 42,
  tableRowHeight: 48,
  tableRowStackedHeight: 56,
  importRowHeight: 72,
  importThumb: 44,
  vehiclePreviewHeight: 170,
  vehiclePreviewCalloutHeight: 160,
  tabHeight: 42,
  chipHeight: 24,
  filterChipHeight: 34,
  zoneTagHeight: 20,
  controlHeightSmall: 32,
  controlHeight: 40,
  controlHeightLarge: 44,
  focusRingWidth: 3,
  caretRoom: 2,
  tooltipArrow: 10,
  tooltipOffset: 10,
  tooltipTouchOffset: 24,
  pagePaddingMobile: 16,
  controlInsetSmall: 12,
  controlInset: 16,
  controlInsetLarge: 20,
  controlGapSmall: 4,
  controlGap: 8,
  tickRowGap: 16,
  tickBoxInset: 7,
  tickLabelDrop: 1,
  signInOptionGap: 12,
  settingsFieldWidth: 320,
  ladderFieldWidth: 104,
  switchTrackInset: 2,
  iconButtonSize: 36,
  iconButtonSizeLarge: 40,
  commandButtonSize: 44,
  commandCellWidth: 72,
  commandLabelLines: 2,
  keyValueLabelWidth: 110,
  keyValueLabelMax: 320,
  keyValueLabelWidthWide: 200,
  keyValueLabelShare: 45,
  keyValueRowHeight: 28,
  mapCalloutWidth: 380,
  mapMarkerDot: 10,
  mapMarkerRing: 2,
  mapMarkerCar: 44,
  allowanceTrack: 72,
  hintToneTile: 32,
  meterHeight: 8,
  meterSegmentGap: 2,
  sparklineWidth: 96,
  sparklineHeight: 24,
  vendorMark: 32,
  vendorMarkLarge: 40,
  chartPlotHeight: 200,
  chartPlotHeightCompact: 160,
  dialogWidth: 480,
  dialogWidthForm: 560,
  qrCode: 144,
} as const


/** The identifier chip: its ground, its ink, its radius and (the part that was hard-coded to the default hairline and vanished) its edge. */
export const codeTag = {
  radius: 'inline',
  ground: 'surfaceSunken',
  ink: 'text2',
  height: 24,
  edge: 'borderStrong',
  edgeUsedFor: 'Not the default hairline. The chip\'s own fill is surfaceSunken and it sits inside a card that is surface, so `border` at 1.10:1 against paper leaves it with no boundary at all and the chip reads as a smudge of fill rather than as a tag, which is the report against the Developer panel\'s SQL ID. borderStrong is the role the source already names for an emphasised rule and is what Table.ts reached for when the same argument came up for a panel frame. controlEdge is rejected: at 3.72:1 on surface it is the role for a control that has nothing but its boundary to say it exists, and a twenty-site identifier chip outlined in mid-grey stops being a tag and becomes a box',
} as const


/** One glyph per verb, and one glyph per status. A rename is a change here, not a sweep through components. */
export const icons = {
  sizes: {
    chip: 14,
    dense: 16,
    control: 18,
    toolbar: 20,
    action: 24,
  },
  grid: 24,
  packs: {
    lucide: {
      render: 'stroked',
    },
    tabler: {
      render: 'stroked',
    },
    beast: {
      render: 'stroked',
    },
    mdi: {
      render: 'filled',
    },
  },
  strokes: {
    chip: 1.35,
    dense: 1.3,
    control: 1.25,
    toolbar: 1.2,
    action: 1.2,
    solo: 1.3,
  },
  optical: {
    glyphs: {
      'lucide:briefcase': {
        scale: 0.92,
      },
      'lucide:refresh-cw': {
        scale: 0.92,
      },
      'lucide:clock': {
        scale: 0.92,
      },
      'lucide:route': {
        scale: 0.92,
      },
    },
  },
  verbs: {
    view: {
      icon: 'lucide:eye',
    },
    open: {
      icon: 'lucide:arrow-up-right',
    },
    openExternal: {
      icon: 'lucide:external-link',
    },
    time: {
      icon: 'lucide:clock',
    },
    history: {
      icon: 'lucide:history',
    },
    edit: {
      icon: 'lucide:pencil',
    },
    delete: {
      icon: 'lucide:trash-2',
    },
    voidRecord: {
      icon: 'lucide:file-x',
    },
    export: {
      icon: 'lucide:download',
    },
    import: {
      icon: 'lucide:upload',
    },
    undo: {
      icon: 'lucide:undo-2',
    },
    copy: {
      icon: 'lucide:copy',
    },
    filter: {
      icon: 'lucide:filter',
    },
    search: {
      icon: 'lucide:search',
    },
    sort: {
      icon: 'lucide:chevrons-up-down',
    },
    more: {
      icon: 'lucide:more-vertical',
    },
    add: {
      icon: 'lucide:plus',
    },
    refresh: {
      icon: 'lucide:refresh-cw',
    },
    link: {
      icon: 'lucide:link',
    },
    close: {
      icon: 'lucide:x',
    },
    unlock: {
      icon: 'tabler:lock-open',
    },
    lock: {
      icon: 'tabler:lock',
    },
    enableDrive: {
      icon: 'tabler:steering-wheel',
    },
    flashLights: {
      icon: 'tabler:bulb',
    },
    honk: {
      icon: 'tabler:speakerphone',
    },
    climate: {
      icon: 'tabler:temperature',
    },
    charge: {
      icon: 'tabler:bolt',
    },
    pluggedIn: {
      icon: 'tabler:plug',
    },
    battery: {
      icon: 'tabler:battery-automotive',
    },
    range: {
      icon: 'tabler:gauge',
    },
    vehicle: {
      icon: 'tabler:car',
    },
    rentals: {
      icon: 'lucide:route',
    },
    wake: {
      icon: 'tabler:alarm',
    },
    locate: {
      icon: 'lucide:map-pin',
    },
    fitToView: {
      icon: 'lucide:maximize',
    },
    recentre: {
      icon: 'lucide:crosshair',
    },
    openChargePort: {
      icon: 'tabler:plug-connected',
    },
    openFrunk: {
      icon: 'tabler:box',
    },
    openTrunk: {
      icon: 'tabler:luggage',
    },
    revoke: {
      icon: 'lucide:shield-off',
    },
    disable: {
      icon: 'lucide:power',
    },
    move: {
      icon: 'lucide:arrow-right-left',
    },
    refund: {
      icon: 'lucide:rotate-ccw',
    },
    cancelRental: {
      icon: 'lucide:ban',
    },
  },
  sections: {
    map: {
      icon: 'lucide:map-pin',
    },
    fleet: {
      icon: 'lucide:zap',
    },
    rentals: {
      icon: 'lucide:route',
    },
    charging: {
      icon: 'tabler:charging-pile',
    },
    fleetManagement: {
      icon: 'lucide:clipboard-list',
    },
    subscriptions: {
      icon: 'lucide:refresh-cw',
    },
    business: {
      icon: 'lucide:briefcase',
    },
    misc: {
      icon: 'lucide:more-horizontal',
    },
    account: {
      icon: 'lucide:settings',
    },
    marketing: {
      icon: 'lucide:newspaper',
    },
  },
  status: {
    rental: {
      booked: 'lucide:calendar-clock',
      booking: 'lucide:calendar',
      freestyle: 'lucide:route',
      started: 'tabler:steering-wheel',
      completed: 'lucide:check-circle',
      cancelled: 'lucide:ban',
      pending: 'lucide:hourglass',
      failed: 'lucide:x-circle',
      default: 'lucide:help-circle',
    },
    invoice: {
      open: 'lucide:send',
      pending: 'lucide:file-text',
      paid: 'lucide:credit-card',
      failed: 'lucide:alert-circle',
      refunded: 'lucide:rotate-ccw',
      default: 'lucide:help-circle',
    },
    subscription: {
      pending: 'lucide:hourglass',
      active: 'lucide:check-circle',
      rejected: 'lucide:x-circle',
      cancelled: 'lucide:ban',
      default: 'lucide:help-circle',
    },
    providerSubscription: {
      active: 'lucide:check-circle',
      trialing: 'lucide:clock',
      past_due: 'lucide:alert-circle',
      unpaid: 'lucide:alert-circle',
      canceled: 'lucide:ban',
      incomplete: 'lucide:hourglass',
      incomplete_expired: 'lucide:x-circle',
      paused: 'lucide:pause-circle',
      default: 'lucide:help-circle',
    },
    subscriptionTier: {
      personal: 'lucide:user',
      business: 'lucide:briefcase',
      default: 'lucide:help-circle',
    },
    user: {
      valid: 'lucide:shield',
      blocked: 'lucide:ban',
      deleted: 'lucide:trash-2',
      default: 'lucide:help-circle',
    },
    vehicleApplication: {
      submitted: 'lucide:hourglass',
      approved: 'lucide:check-circle',
      rejected: 'lucide:x-circle',
      deactivated: 'lucide:ban',
      default: 'lucide:help-circle',
    },
    vehicleKey: {
      ok: 'lucide:shield',
      notSupported: 'lucide:shield-off',
      missing: 'lucide:alert-circle',
      unknown: 'lucide:help-circle',
      default: 'lucide:help-circle',
    },
    ownerKey: {
      needed: 'lucide:key-round',
      default: 'lucide:help-circle',
    },
    vehicleAvailability: {
      free: 'lucide:circle-dot',
      rented: 'lucide:loader-pinwheel',
      driving: 'lucide:loader-pinwheel',
      disabled: 'lucide:circle-minus',
      default: 'lucide:help-circle',
    },
    teslaConnection: {
      connected: 'lucide:check-circle',
      revoked: 'lucide:x-circle',
      default: 'lucide:help-circle',
    },
    teslaImport: {
      imported: 'lucide:check-circle',
      importedByAnotherProvider: 'lucide:lock',
      started: 'lucide:hourglass',
      default: 'lucide:help-circle',
    },
    capability: {
      unavailable: 'lucide:x-circle',
      locked: 'lucide:lock',
      withdrawn: 'lucide:minus-circle',
      default: 'lucide:help-circle',
    },
    erasure: {
      scheduled: 'lucide:clock',
      banned: 'lucide:ban',
      outstandingDebt: 'lucide:banknote',
      openRiskRecord: 'lucide:search',
      beastStaff: 'lucide:shield',
      partnerAccountActive: 'lucide:briefcase',
      activeRental: 'lucide:car',
      partnerFleetInUse: 'lucide:users',
      default: 'lucide:help-circle',
    },
    marketingCampaign: {
      pending: 'lucide:hourglass',
      processing: 'lucide:loader',
      sending: 'lucide:send',
      completed: 'lucide:check-circle',
      cancelled: 'lucide:ban',
      default: 'lucide:help-circle',
    },
    opsSubTask: {
      cleaningExterior: 'beast:car-wash',
      cleaningInterior: 'lucide:spray-can',
      refillingFluid: 'lucide:droplet',
      charging: 'tabler:bolt',
      resetSettings: 'lucide:sliders',
      default: 'lucide:help-circle',
    },
    promoCode: {
      active: 'lucide:check-circle',
      scheduled: 'lucide:hourglass',
      expired: 'lucide:calendar-x',
      exhausted: 'lucide:circle-slash',
      disabled: 'lucide:ban',
      default: 'lucide:help-circle',
    },
    provenance: {
      booked: 'lucide:file-check-2',
      fromVendor: 'lucide:plug',
      estimated: 'lucide:calculator',
      expected: 'lucide:hourglass',
      freePlan: 'lucide:star',
      notInUse: 'lucide:calendar-off',
      default: 'lucide:help-circle',
    },
    superchargerBill: {
      waiting: 'lucide:hourglass',
      due: 'lucide:clock',
      charged: 'lucide:credit-card',
      failing: 'lucide:alert-circle',
      unpaid: 'lucide:banknote',
      waived: 'lucide:ban',
      not_billed: 'lucide:minus-circle',
      default: 'lucide:help-circle',
    },
    businessInvoice: {
      issued: 'lucide:file-check',
      held: 'lucide:hand',
      default: 'lucide:help-circle',
    },
  },
  statusLive: {
    vehicleAvailability: [
      'rented',
      'driving',
    ],
  },
  turn: {
    'lucide:loader-pinwheel': 'counterclockwise',
  },
  answer: {
    yes: 'lucide:check',
    no: 'lucide:minus',
  },
  unit: {
    percentage: 'lucide:percent',
    beastBucks: 'beast:bucks',
    currency: {
      EUR: 'lucide:euro',
      USD: 'lucide:dollar-sign',
      default: 'lucide:banknote',
    },
  },
  tone: {
    info: 'lucide:info',
    attention: 'lucide:alert-triangle',
    warning: 'lucide:alert-triangle',
    error: 'lucide:siren',
    success: 'lucide:check-circle',
    tip: 'lucide:message-square-warning',
  },
  vehicleState: {
    online: 'lucide:wifi',
    asleep: 'lucide:moon',
    charging: 'tabler:bolt',
    inService: 'lucide:wrench',
    offline: 'lucide:wifi-off',
    default: 'lucide:help-circle',
  },
  addon: {
    energy_limit_v2: 'tabler:road',
    deductible: 'lucide:shield-check',
    additional_driver: 'lucide:user-plus',
    roof_box: 'lucide:package',
    child_seat: 'lucide:baby',
    pet_cage: 'lucide:paw-print',
    full_charge: 'lucide:battery-full',
    booking_location_start: 'lucide:map-pin',
    booking_location_end: 'lucide:map-pin-check',
    custom: 'lucide:message-square-text',
    default: 'lucide:circle-plus',
  },
  commands: {
    WAKE_UP: 'lucide:power',
    DOOR_LOCK: 'lucide:lock',
    DOOR_UNLOCK: 'lucide:lock-open',
    FLASH_LIGHTS: 'lucide:lightbulb',
    HONK_HORN: 'lucide:megaphone',
    START_CLIMATE: 'lucide:thermometer-sun',
    STOP_CLIMATE: 'lucide:thermometer-snowflake',
    START_PRECONDITIONING_MAX: 'lucide:snowflake',
    STOP_PRECONDITIONING_MAX: 'lucide:sun',
    CLOSE_WINDOWS: 'tabler:car-door',
    ENABLE_SENTRY_MODE: 'lucide:shield-check',
    DISABLE_SENTRY_MODE: 'lucide:shield-off',
    FART: 'lucide:wind',
    CHARGE_PORT_DOOR_OPEN: 'tabler:bolt',
    OPEN_FRUNK: 'beast:frunk',
    OPEN_TRUNK: 'beast:trunk',
    REMOTE_START_DRIVE: 'tabler:steering-wheel',
  },
} as const


/** What colour a car actually is. Paint, not palette: it carries no state and means nothing. */
export const vehiclePaint = {
  paint: {
    armyGreen: '#5A6144',
    black: '#1B1D20',
    blue: '#2C5AA8',
    blueCamo: '#4A6B8A',
    deepBlue: '#1E3A5F',
    midnightSilver: '#4B5057',
    orangeCamo: '#B5713A',
    red: '#A31621',
    redCamo: '#8C4A46',
    roseGold: '#C4907A',
    rosePink: '#D19BA6',
    white: '#F2F3F5',
  },
} as const


/** Four tiers, inclusive at the top of each. The boundary at 25 is a test, not a comment. */
export const battery = {
  tiers: [
    {
      name: 'critical',
      max: 10,
      semantic: 'error',
      label: 'Critical',
      icon: 'tabler:battery-1',
    },
    {
      name: 'low',
      max: 25,
      semantic: 'warning',
      label: 'Low',
      icon: 'tabler:battery-2',
    },
    {
      name: 'reduced',
      max: 49,
      semantic: 'attention',
      label: 'Reduced',
      icon: 'tabler:battery-3',
    },
    {
      name: 'ready',
      max: 100,
      semantic: 'success',
      label: 'Ready',
      icon: 'tabler:battery-4',
    },
  ],
  meter: {
    cellWidth: 24,
    cellHeight: 12,
    borderWidth: 1,
    inset: 2,
    nubWidth: 2,
    nubHeight: 4,
  },
} as const


/** Points at which a drawing changes what it says: a free allowance meter turning to attention, and a segmented meter giving way to words. */
export const thresholdTokens = {
  allowanceAttention: 0.8,
  meterSegmentsMax: 30,
} as const


/** Freshness thresholds per data class. A telemetry reading goes stale in minutes; a warranty record does not. */
export const freshness = {
  states: {
    fresh: 'Normal value, quiet timestamp under the block',
    recent: 'Normal value with a relative age next to it, refresh available',
    stale: 'Value in secondary text with a dashed underline, age in attention colour, refresh offered as the primary action of the block',
    unknown: 'The word Unknown. Not a blank, not a dash and never a zero',
    unreachable: 'Last known value, the time it was true, and the state that ended it',
  },
  policies: {
    telemetry: {
      recentAfterMs: 120000,
      staleAfterMs: 900000,
    },
    maintenance: {
      recentAfterMs: 86400000,
      staleAfterMs: 604800000,
    },
  },
  skewForgivenessMs: 300000,
} as const


/** Consequence classes. Colour and confirmation come from what a command does to a physical car. */
export const command = {
  unknownAfterMs: 30000,
  groups: [
    {
      caption: 'Triggers immediately on vehicle after click/tap',
      classes: [
        'read',
        'reversible',
      ],
    },
    {
      caption: 'Opens the vehicle, but asks for confirm first',
      classes: [
        'access',
      ],
    },
    {
      caption: 'Makes the vehicle drivable',
      classes: [
        'drive',
      ],
    },
  ],
  classes: [
    {
      class: 0,
      name: 'read',
      control: 'secondary',
      confirmation: 'none',
    },
    {
      class: 1,
      name: 'reversible',
      control: 'secondary',
      confirmation: 'none',
    },
    {
      class: 2,
      name: 'access',
      control: 'ink',
      confirmation: 'namesVehicleAndPlace',
    },
    {
      class: 3,
      name: 'drive',
      control: 'ink',
      confirmation: 'namesVehicleAndPlaceAndAcknowledgement',
    },
    {
      class: 4,
      name: 'destructive',
      control: 'danger',
      confirmation: 'namesRecordAndConsequence',
    },
  ],
  outcomes: {
    sent: 'Sent, waiting for the vehicle',
    acknowledged: 'Acknowledged by the vehicle',
    applied: 'Applied and confirmed by a telemetry read',
    refused: 'The car answered and declined, with its own reason in plain words',
    unknown: 'No acknowledgement inside the window. Offers Check state where a read can answer it, never Retry: a timeout is unknown, never failed',
  },
  outcomeModel: {
    target: 'fourOutcome',
    current: 'fourOutcome',
  },
} as const


export const tiers = {
  '1': {
    name: 'Expressive',
    typeCeiling: 52,
    pagePadding: 64,
    radiusRamp: 'expressive',
    motionBudget: [
      'reveal',
      'gloss',
      'crossfade',
      'enter',
      'state',
    ],
    minHitTarget: 44,
    forbids: 'Data tables, dense rows, more than one gradient in view, any control smaller than 44px',
  },
  '2': {
    name: 'Guided',
    typeCeiling: 32,
    pagePadding: 24,
    radiusRamp: 'expressive',
    motionBudget: [
      'sheet',
      'enter',
      'state',
      'pulse',
    ],
    minHitTarget: 44,
    forbids: 'Tables, reveal, gloss, more than one primary action per screen, anything below 44px',
  },
  '3': {
    name: 'Console',
    typeCeiling: 24,
    pagePadding: 24,
    radiusRamp: 'console',
    motionBudget: [
      'state',
      'enter',
      'sheet',
      'pulse',
    ],
    minHitTarget: 40,
    forbids: 'Decorative imagery, resting shadows, display type, reveal, gloss, hero blocks, empty space that costs a row',
  },
} as const
